import Vue from 'vue';
import Vuex from 'vuex';
import auth from './modules/auth';
import createPersistedState from 'vuex-persistedstate';

// Save vuex state in storage.
const plugins = [createPersistedState()];

Vue.use(Vuex);

const store = new Vuex.Store({
    modules: {
        auth,
    },
    plugins
});

export default store;
